import e from "./isBrowser.js";
export default (function () {
  var i = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : e() && window.location.href;
  return i && "string" == typeof i && i.indexOf("?") > 0 ? i.slice(0, i.indexOf("?")) : i;
});